import React from 'react';
import {useNavigate} from 'react-router-dom';
import classNames from 'classnames';
import Button from '../ui/Button';

const DashboardCardWrapper = ({redirectURL = null, title}) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="border-b-2 border-gray-200 pb-2.5 pt-6 px-8">
        <div
          className={classNames(
            'flex font-semibold',
            redirectURL ? 'justify-between' : 'justify-start',
          )}
        >
          <div className="text font-semibold">{title}</div>
          {redirectURL && (
            <Button
              variant="flat"
              className="border-b border-b-primary-light self-center"
              onClick={() => navigate(redirectURL)}
            >
              View All
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default DashboardCardWrapper;
